const EndDevice = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/EndDevice')
const Overview = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/overview/Overview')
const Channels = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/Channels')
const Geolocation = () => import(/* webpackChunkName: "v-endDevice-geoloc" */ '@/components/page/endDevice/geolocation/Geolocation')
// const MacCommands = () => import(/* webpackChunkName: "v-endDevice-mac" */ '@/components/page/endDevice/macCommands/MacCommands')
const Kpi = () => import(/* webpackChunkName: "v-kpi" */ '@/components/page/endDevice/Kpi')
const DataUp = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/DataUp')
const DataDown = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/DataDown')
const Messages = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/Messages')
const Events = () => import(/* webpackChunkName: "v-endDevice" */ '@/components/page/endDevice/Events')

const routes = [
  {
    path: 'end-devices/:devEui',
    component: EndDevice,
    props: true,
    children: [
      {
        path: '',
        name: 'endDevice',
        redirect: 'overview'
      }, {
        path: 'overview',
        name: 'endDeviceOverview',
        props: true,
        component: Overview,
        meta: {
          hasFloatingButton: true
        }
      }, {
        path: 'channels',
        name: 'endDeviceChannels',
        props: true,
        component: Channels
      }, {
        path: 'geolocation',
        name: 'endDeviceGeolocation',
        props: true,
        component: Geolocation
      }, {
      //   path: 'mac-commands',
      //   name: 'endDeviceMacCommands',
      //   props: true,
      //   component: MacCommands,
      //   meta: {
      //     roles: ['ADMIN', 'SUPER_ADMIN']
      //   }
      // }, {
        path: 'kpi',
        name: 'endDeviceKpi',
        props: true,
        component: Kpi
      }, {
        path: 'data-up',
        name: 'endDeviceDataUp',
        props: true,
        component: DataUp
      }, {
        path: 'data-down',
        name: 'endDeviceDataDown',
        props: true,
        component: DataDown,
        meta: {
          hasFloatingButton: true
        }
      }, {
        path: 'messages',
        name: 'endDeviceMessages',
        props: true,
        component: Messages
      }, {
        path: 'events',
        name: 'endDeviceEvents',
        props: true,
        component: Events
      }
    ]
  }
]

export default routes
